export default "__VITE_ASSET__c4f0703b__"